export default __webpack_public_path__ + "2222fac2f9ead6c601ef69385033ba0c.png";